import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import HomeFooter from "../layout/IME/HomeFooter";

const Advertising = ({ auth: { user, isAuthenticated } }) => {
  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {isAuthenticated ? <LoggedInNav /> : <LoggedOutNav />}
      <div className="advertising-container">
        <div className="flex-all">
          <p className="ad-heading green">#imehasNO-ADS!</p>
          <i className="far fa-flushed fa-3x mx-5 green emoji"></i>
        </div>
      </div>
      <HomeFooter />
    </Fragment>
  );
};

Advertising.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(Advertising);
